// Landing Page Component
// ======================
// Feature #287: Updated with new design system - warm canvas background

import React from 'react';
import LandingHeader from './LandingHeader';
import HeroSection from './HeroSection';
import FeaturesSection from './FeaturesSection';
import HowItWorksSection from './HowItWorksSection';
import BetaCallToAction from './BetaCallToAction';
import CTASection from './CTASection';
import Footer from './Footer';

const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-background-light dark:bg-background-dark">
      <LandingHeader />
      <main>
        <HeroSection />
        <FeaturesSection />
        <HowItWorksSection />
        <BetaCallToAction />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
